module.exports = __webpack_public_path__ + "img/電気回路_5_8_4.71417a54.png";